// Коммит НЕблочной загрузки (баннер курса, картинка урока) на время проверки
// курса. Контрол гаснет заранее, но загрузка переживает и его, и смену статуса:
// файл могли бросить за миг до `pending`. Поэтому признак читается РЕФОМ в
// момент коммита, как у блочного пути (`useBlockUploadCommit`).
import { useCallback, useEffect, useRef } from 'react'
import { toast } from 'sonner'
import { useIsCourseFrozen } from '@/features/moderation/useCourseModeration'
import { REVIEW_UPLOAD_REFUSED } from '../../lib/reviewLockText'
import { useFileUpload } from './useFileUpload'
import type { CommitUpload } from './uploadTask'

/**
 * Оборачивает коммит владельца: на проверке запись курса/урока не уходит,
 * только что загруженный файл убирается за собой (он ни на что не ссылается),
 * а `false` бережёт старый — сохранения не было.
 */
export const useFrozenUploadGuard = (
  courseId: number,
): ((commit: CommitUpload) => CommitUpload) => {
  const isFrozen = useIsCourseFrozen(courseId)
  const frozenRef = useRef(isFrozen)
  useEffect(() => {
    frozenRef.current = isFrozen
  })
  const { removeFile } = useFileUpload()

  return useCallback(
    (commit: CommitUpload): CommitUpload =>
      (url) => {
        if (!frozenRef.current) return commit(url)
        removeFile(url)
        toast.error(REVIEW_UPLOAD_REFUSED)
        return false
      },
    [removeFile],
  )
}
